import TabletopUniverse from "../TabletopUniverse";
import ITabletopDrawableElement from "./ITabletopDrawableElement";

export default abstract class TabletopElement {
    public universe: TabletopUniverse | null = null;

    isDrawable(): this is ITabletopDrawableElement {
        return "draw" in this;
    }
}
